import React, { ReactElement, useEffect, useState } from "react";
import { Select, Text } from "@xometry/xometry_loft";
import Modal from "../Common/Modal";
import { FormErrorStyles, ModalInputContainer, ModalStyles } from "./styles";
import { FullFormFragment } from "../../../schema/generated/schema";
import { sellerOnlyForms } from "../utils";

interface AddFormModalProps {
  modalOpen: boolean;
  setModal: (boolean) => void;
  onSubmit?: (
    formId: string,
    formName: string
  ) => void | { errorMessage: string };
  forms: readonly FullFormFragment[];
}

const AddFormModal = ({
  modalOpen,
  setModal,
  onSubmit,
  forms,
}: AddFormModalProps): ReactElement => {
  const [form, setForm] = useState({ formId: "", formName: "" });
  const [formError, setFormError] = useState("");

  useEffect(() => {
    setForm({ formId: "", formName: "" });
  }, [modalOpen]);

  return (
    <Modal
      isOpen={modalOpen}
      selector="#modal-mount"
      title={<Text kind="panel-title">Add Item</Text>}
      submitActionText="Add"
      discardActionText="Dismiss"
      handleSubmit={() => {
        if (onSubmit) {
          const onSubmitResponse = onSubmit(form.formId, form.formName);
          if (onSubmitResponse?.errorMessage) {
            setFormError(onSubmitResponse.errorMessage);
          } else {
            setModal(false);
          }
        }
      }}
      handleCloseButton={() => {
        setModal(false);
        setFormError("");
      }}
      handleCancel={() => {
        setModal(false);
        setFormError("");
      }}
      cssStyle={ModalStyles}
      buttonScale="large"
    >
      <ModalInputContainer>
        <Select
          name="addForm"
          onChange={({ target }) => {
            setForm({
              formId: target.value,
              formName: forms.find(f => f.id === target.value)?.name || "",
            });
          }}
          scale="large"
          required
          value={form.formId}
        >
          <option value="" disabled>
            Select an option...
          </option>
          {forms
            .slice()
            .sort((a, b) =>
              a.name.toLowerCase().localeCompare(b.name.toLowerCase())
            )
            .map(form => (
              <option key={form.id} value={form.id}>
                {`${form.name} (${form.slug})`}
                {sellerOnlyForms.includes(form.name) && " (seller only)"}
              </option>
            ))}
        </Select>
        <span css={FormErrorStyles}>{formError}</span>
      </ModalInputContainer>
    </Modal>
  );
};

AddFormModal.defaultProps = {
  onSubmit: undefined,
};

export default AddFormModal;
